import { render } from "./layout.vue?vue&type=template&id=4d9b5ad7"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"

import "./layout.vue?vue&type=style&index=0&id=4d9b5ad7&lang=less"
script.render = render

export default script